"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisPosition = void 0;
var AxisPosition;
(function (AxisPosition) {
    AxisPosition[AxisPosition["Rows"] = 1] = "Rows";
    AxisPosition[AxisPosition["Columns"] = 2] = "Columns";
})(AxisPosition = exports.AxisPosition || (exports.AxisPosition = {}));
//# sourceMappingURL=AxisPosition.js.map